var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import ReactTable from "react-table";
import { Button, Dimmer, Grid, Header, Input, Loader, Menu, Message, Modal, Select, Table } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { MetaCatalogLoader } from "../kit/Catalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { CatalogMode, getWithAuthn } from "../RequestHelpers";
import { displayLocalTimestamp } from "./AllOrdersPage";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UploadFileModal from "./UploadFileModal";
var ProDetectTrackingPage = /** @class */ (function (_super) {
    __extends(ProDetectTrackingPage, _super);
    function ProDetectTrackingPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProDetectTrackingPage.prototype.render = function () {
        var renderer = function (catalog) {
            return React.createElement(ProDetectTrackingContent, { catalog: catalog });
        };
        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: renderer });
    };
    return ProDetectTrackingPage;
}(React.PureComponent));
export default ProDetectTrackingPage;
var ProDetectTrackingContent = /** @class */ (function (_super) {
    __extends(ProDetectTrackingContent, _super);
    function ProDetectTrackingContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTable = function (resp) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Platform"),
                        React.createElement(Table.HeaderCell, null, "Enzyme"),
                        React.createElement(Table.HeaderCell, null, "Plexity"),
                        ALIQUOTS.map(function (a) { return React.createElement(Table.HeaderCell, { key: a.key }, a.label); }))),
                React.createElement(Table.Body, null, resp.proDetects.map(function (entry) {
                    return React.createElement(Table.Row, { key: entry.id },
                        React.createElement(Table.Cell, null,
                            entry.platform.label,
                            " ",
                            _this.editProDetectEntry(entry)),
                        React.createElement(Table.Cell, null, entry.enzyme.label),
                        React.createElement(Table.Cell, null, entry.plexity),
                        ALIQUOTS.map(function (a) { return React.createElement(Table.Cell, { key: a.key }, entry[a.key]); }));
                })));
        };
        _this.renderEventsTable = function (resp) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, "Events"),
                React.createElement(ReactTable, { columns: [
                        {
                            id: 'name',
                            Header: 'User',
                            accessor: function (e) { return e.user.name; }
                        },
                        {
                            id: 'type',
                            Header: 'Type',
                            accessor: function (e) { return e.type; }
                        },
                        {
                            id: 'platform',
                            Header: 'Platform',
                            accessor: function (e) { return e.platform.label; }
                        },
                        {
                            id: 'enzyme',
                            Header: 'Enzyme',
                            accessor: function (e) { return e.enzyme.label; }
                        },
                        {
                            id: 'plexity',
                            Header: 'Plexity',
                            accessor: function (e) { return e.plexity; }
                        },
                        {
                            id: 'msg',
                            Header: 'Message',
                            accessor: function (e) { return e.msg; },
                            Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                        },
                        {
                            id: 'createdAt',
                            Header: 'Created',
                            accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                        },
                    ], data: resp.proDetectEvents, defaultPageSize: 50, defaultSorted: [{
                            id: 'createdAt'
                        }], minRows: 1 }));
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/inventory/pro-detects')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                    _this.setState({ loading: false, error: true });
                });
            });
        };
        _this.inputNewAliquots = function () {
            var renderProDetectModal = function (props) {
                return React.createElement(ProDetectModal, __assign({ catalog: _this.props.catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Input new aliquots' }) },
                React.createElement(Modal.Header, null, "Input new aliquots"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderProDetectModal, successMessage: 'New aliquots inputted' })));
        };
        _this.editProDetectEntry = function (proDetectEntry) {
            var renderProDetectModal = function (props) {
                return React.createElement(ProDetectModal, __assign({ proDetectEntry: proDetectEntry, catalog: _this.props.catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'edit', size: 'mini' }) },
                React.createElement(Modal.Header, null, "Edit Pro detect inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderProDetectModal, successMessage: 'Inventory updated' })));
        };
        _this.uploadInventory = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload inventory' }) },
                React.createElement(Modal.Header, null, "Upload inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement("p", null,
                        "Columns: Platform, Enzyme, Plexity, ",
                        ALIQUOTS.map(function (a) { return a.label; }).join(", "),
                        ". Platform and enzyme use their ids (e.g. LEICA, HRP)."),
                    React.createElement(UploadFileModal, { path: "/admin/inventory/pro-detects/upload-current-inventory" })));
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    ProDetectTrackingContent.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'non-header-portion' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            React.createElement(Menu, null,
                React.createElement(Menu.Item, null, this.uploadInventory()),
                React.createElement(Menu.Item, null, this.inputNewAliquots())),
            this.state.response && this.renderTable(this.state.response),
            this.state.response && this.renderEventsTable(this.state.response));
    };
    ProDetectTrackingContent.prototype.componentDidMount = function () {
        this.loadData();
    };
    return ProDetectTrackingContent;
}(React.PureComponent));
var ProDetectModal = /** @class */ (function (_super) {
    __extends(ProDetectModal, _super);
    function ProDetectModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onPlatformChange = function (_, data) {
            var platform = _this.props.catalog.rnaCatalog.proPlatforms.find(function (p) { return p.id === data.value; });
            if (platform === undefined) {
                throw new RangeError("Could not find platform " + data.value);
            }
            // Keep the plexity only if the new platform supports it
            var plexities = platform.plexity.map(function (p) { return Number(p); });
            var plexity = _this.state.plexity !== undefined && plexities.includes(_this.state.plexity)
                ? _this.state.plexity
                : plexities[0];
            _this.setState({ platformId: platform.id, plexity: plexity });
        };
        _this.onEnzymeChange = function (_, data) {
            _this.setState({ enzymeId: data.value });
        };
        _this.onPlexityChange = function (_, data) {
            _this.setState({ plexity: data.value });
        };
        _this.onAliquotChange = function (key) {
            return function (_, data) {
                var num = parseInt(data.value, 10);
                if (isNaN(num)) {
                    // no op -- discard input
                    return;
                }
                _this.setState(function (s) {
                    var _a;
                    return ({ aliquots: __assign(__assign({}, s.aliquots), (_a = {}, _a[key] = num, _a)) });
                });
            };
        };
        _this.submit = function () {
            var entry = _this.props.proDetectEntry;
            if (entry == null) {
                _this.props.postRequest("/admin/inventory/pro-detects/add-new-aliquots", __assign({ platformId: _this.state.platformId, enzymeId: _this.state.enzymeId, plexity: _this.state.plexity }, _this.state.aliquots));
            }
            else {
                // Only send the counts that changed; null leaves a count as is
                var changed = ALIQUOTS.reduce(function (acc, a) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[a.key] = entry[a.key] === _this.state.aliquots[a.key] ? null : _this.state.aliquots[a.key], _a)));
                }, {});
                _this.props.postRequest("/admin/inventory/pro-detects/update-existing-entry/id/" + encodeURIComponent(entry.id), changed);
            }
        };
        var entry = props.proDetectEntry;
        _this.state = {
            platformId: entry === null || entry === void 0 ? void 0 : entry.platform.id,
            enzymeId: entry === null || entry === void 0 ? void 0 : entry.enzyme.id,
            plexity: entry === null || entry === void 0 ? void 0 : entry.plexity,
            aliquots: entry
                ? ALIQUOTS.reduce(function (acc, a) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[a.key] = entry[a.key], _a)));
                }, EMPTY_ALIQUOTS)
                : EMPTY_ALIQUOTS
        };
        return _this;
    }
    ProDetectModal.prototype.render = function () {
        var _this = this;
        var _a;
        var editing = this.props.proDetectEntry != null;
        var platforms = this.props.catalog.rnaCatalog.proPlatforms;
        var enzymes = this.props.catalog.rnaCatalog.proAmplifier.enzymes;
        var selectedPlatform = platforms.find(function (p) { return p.id === _this.state.platformId; });
        var platformOptions = platforms.map(function (p) { return ({ key: p.id, text: p.label, value: p.id }); });
        var enzymeOptions = enzymes.map(function (e) { return ({ key: e.id, text: e.label, value: e.id }); });
        // Offer the plexities the platform supports; when editing, the entry's plexity is all that's needed
        var plexities = editing
            ? [this.state.plexity]
            : ((_a = selectedPlatform === null || selectedPlatform === void 0 ? void 0 : selectedPlatform.plexity) !== null && _a !== void 0 ? _a : []).map(function (p) { return Number(p); });
        var plexityOptions = plexities.map(function (p) { return ({ key: p, text: p + "-plex", value: p }); });
        var canSubmit = this.state.platformId !== undefined && this.state.enzymeId !== undefined
            && this.state.plexity !== undefined;
        return React.createElement(Grid, { columns: 3 },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/platform', errors: this.props.state.errors, labelContent: 'Platform' },
                        React.createElement(Select, { name: 'platform', disabled: editing, onChange: this.onPlatformChange, placeholder: 'Select...', options: editing ? [{
                                    key: this.props.proDetectEntry.platform.id,
                                    text: this.props.proDetectEntry.platform.label,
                                    value: this.props.proDetectEntry.platform.id
                                }] : platformOptions, value: this.state.platformId }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/enzyme', errors: this.props.state.errors, labelContent: 'Enzyme' },
                        React.createElement(Select, { name: 'enzyme', disabled: editing, onChange: this.onEnzymeChange, placeholder: 'Select...', options: editing ? [{
                                    key: this.props.proDetectEntry.enzyme.id,
                                    text: this.props.proDetectEntry.enzyme.label,
                                    value: this.props.proDetectEntry.enzyme.id
                                }] : enzymeOptions, value: this.state.enzymeId }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/plexity', errors: this.props.state.errors, labelContent: 'Plexity' },
                        React.createElement(Select, { name: 'plexity', disabled: editing || selectedPlatform === undefined, onChange: this.onPlexityChange, placeholder: 'Select...', options: plexityOptions, value: this.state.plexity })))),
            React.createElement(Grid.Row, null, ALIQUOTS.map(function (a) {
                return React.createElement(Grid.Column, { key: a.key },
                    React.createElement(FieldWithErrorDisplay, { errors: _this.props.state.errors, errorPath: "/" + a.key, labelContent: a.label },
                        React.createElement(Input, { onChange: _this.onAliquotChange(a.key), placeholder: '0', type: "number", value: _this.state.aliquots[a.key] })));
            })),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success || !canSubmit, icon: 'plus', label: editing ? 'Save update' : 'Add new Pro detect aliquots', labelPosition: 'left', onClick: this.submit, positive: true }))));
    };
    return ProDetectModal;
}(React.PureComponent));
var ALIQUOTS = [
    { key: "slides10Aliquots", label: "10 slide aliquots" },
    { key: "slides20Aliquots", label: "20 slide aliquots" },
    { key: "slides42Aliquots", label: "42 slide aliquots" },
    { key: "slides50Aliquots", label: "50 slide aliquots" },
    { key: "slides90Aliquots", label: "90 slide aliquots" }
];
var EMPTY_ALIQUOTS = {
    slides10Aliquots: 0,
    slides20Aliquots: 0,
    slides42Aliquots: 0,
    slides50Aliquots: 0,
    slides90Aliquots: 0
};
//# sourceMappingURL=ProDetectTrackingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ProDetectTrackingPage.js
// module id = 1476
// module chunks = 0